import { Vue, Component } from 'nuxt-property-decorator'
import { Capacitor } from '@capacitor/core'
import { IStyle } from '~/assets/interfaces/classes'
import { classDevice } from '~/assets/functions/class-device'

@Component
export default class MixinGeneral extends Vue {
  public classDevice = classDevice(this.$device)
  public $style!: IStyle

  public isNativePlatform = Capacitor.isNativePlatform()
  public isMobile = this.$device.isMobileOrTablet
}
